import { getErrorMessage } from '../utils/util.errors';
import services from './../config/services';
import axios from 'axios';
import {
	GET_ERRORS, UPLOAD_FILE,
	PENDIG_IMAGES, MARK_AS_COMPLETED,
	DELETE_IMAGES, PRODUCTS_WITH_IMAGES,
	FEATURED_PRODUCTS,
	GET_ALL_PRODUCTS,
	DEACTIVATE_FEATURED_PRODUCTS,
	UPDATE_FEATURED_PRODUCTS,
	PRODUCT_IMAGE_SAVED
} from './types';

const URL_DEACTIVATE_FEATURED_PRODUCT  = process.env.REACT_APP_API_URL + services.deactivateFeaturedProduct;
const URL_UPDATE_FEATURED_PRODUCTS     = process.env.REACT_APP_API_URL + services.updateFeaturedProducts;
const URL_GET_PRODUCTS_WITH_IMAGES     = process.env.REACT_APP_API_URL + services.productsWithImages;
const URL_GET_INFO_PRODUCT_IMAGE_SAVED = process.env.REACT_APP_API_URL + services.productImageSaved;
const URL_GET_FEATURED_PRODUCTS        = process.env.REACT_APP_API_URL + services.featuredProducts;
const URL_MARK_AS_COMPLETED            = process.env.REACT_APP_API_URL + services.markAsCompleted;
const URL_GET_ALL_PRODUCTS             = process.env.REACT_APP_API_URL + services.getAllProducts;
const URL_GET_PENDING_IMAGES           = process.env.REACT_APP_API_URL + services.pendingImages;
const URL_DELETE_IMAGES                = process.env.REACT_APP_API_URL + services.deleteImages;

export const UploadFile = (file) => dispatch => {

	const URL_API = process.env.REACT_APP_API_URL + '/v2/products/upload';
	const formData = new FormData();
	formData.append('excel', file);

	axios({
		method: 'POST',
		url: URL_API,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
	.then(res => {
		dispatch({
			type: UPLOAD_FILE,
			payload: res.data.result
		})
	})
	.catch(error => {
		dispatch({
			type: GET_ERRORS,
			payload: getErrorMessage(error)
		})
	});
}

export const UploadImage = (images) => dispatch => {
	const URL_API = process.env.REACT_APP_API_URL + services.uploadImages;
	axios.post(URL_API, images)
		.then(res => {
			dispatch({
				type: UPLOAD_FILE,
				payload: res.data.result
			});
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const GetPendingImages = (resolution = '900x900', limit = 25, page = 1, noSap = null) => dispatch => {

	let params = {
		resolution: resolution,
		limit: limit,
		page: page
	};
	if (noSap)
		params.no_sap = noSap;

	axios
		.post(URL_GET_PENDING_IMAGES, params)
		.then((res) => {
			dispatch({
				type: PENDIG_IMAGES,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)

			})
		});
}

export const MarkAsCompleted = (nosap, resolution = '900x900') => dispatch => {
	const params = {
		no_sap: nosap,
		resolution: resolution
	};
	axios
		.put(URL_MARK_AS_COMPLETED, params)
		.then((res) => {
			dispatch({
				type: MARK_AS_COMPLETED,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const GetProductsWithImages = (nosap, resolution) => dispatch => {
	let url = URL_GET_PRODUCTS_WITH_IMAGES;
	if (nosap && resolution) url += '?nosap=' + nosap + '&resolution=' + resolution;
	axios
		.get(url)
		.then((res) => {
			dispatch({
				type: PRODUCTS_WITH_IMAGES,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const DeleteImage = (urlImage) => dispatch => {
	const url = URL_DELETE_IMAGES + urlImage
	axios
		.delete(url, { params: { 'url': urlImage } })
		.then((res) => {
			dispatch({
				type:    DELETE_IMAGES,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type:    GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const getAllProducts = () => dispatch => {
	axios
		.get(URL_GET_ALL_PRODUCTS)
		.then(res => {
			dispatch({
				type: GET_ALL_PRODUCTS,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};

export const GetFeaturedProducts = () => dispatch => {
	axios
		.get(URL_GET_FEATURED_PRODUCTS)
		.then((res) => {
			dispatch({
				type: FEATURED_PRODUCTS,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const UpdateFeaturedProducts = (products) => dispatch => {
	axios
		.post(URL_UPDATE_FEATURED_PRODUCTS, { featuredProducts: products })
		.then((res) => {
			dispatch({
				type: UPDATE_FEATURED_PRODUCTS,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const DeactivateFeaturedProduct = (product) => dispatch => {
	axios
		.post(URL_DEACTIVATE_FEATURED_PRODUCT, { featuredProduct: product })
		.then((res) => {
			dispatch({
				type: DEACTIVATE_FEATURED_PRODUCTS,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const GetProductImageSavedData = (nosap) => dispatch => {
	let url = URL_GET_INFO_PRODUCT_IMAGE_SAVED;
	if (nosap) url += '?no_sap=' + nosap;
	axios
	.get(url).then((res) => {
        dispatch({
            type:    PRODUCT_IMAGE_SAVED,
            payload: res.data.result
        })
    }).catch(error => {
        dispatch({
            type:    GET_ERRORS,
            payload: getErrorMessage(error)
        })
    });

}